import React from "react";
import { render } from "react-dom";

import Uit from "./uit";

const container = [...document.querySelectorAll(".js-special-uit")];

container.map((item) =>
  render(
    <Uit
      title={item.dataset.title}
      description={item.dataset.description}
      url={item.dataset.url}
      buttonText={item.dataset.buttonText}
    />,
    item
  )
);
